module.exports = __webpack_public_path__ + "static/img/example5.51586f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/chainmanage/image/example5.jpg
// module id = 711
// module chunks = 1